import script from "./SavedBlockDisplay.vue?vue&type=script&lang=ts&setup=true"
export * from "./SavedBlockDisplay.vue?vue&type=script&lang=ts&setup=true"

import "./SavedBlockDisplay.vue?vue&type=style&index=0&id=7d6724f8&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d6724f8"]])

export default __exports__